import React from 'react';
import IconBase from './IconBase';

const VerifiedIcon = props => {
    return (
        <IconBase {...props}>
            <path d="M8.6,22.5l-1.9-3.2-3.6-.8.35-3.7-2.45-2.8,2.45-2.8-.35-3.7,3.6-.8,1.9-3.2,3.4,1.45,3.4-1.45,1.9,3.2,3.6.8-.35,3.7,2.45,2.8-2.45,2.8.35,3.7-3.6.8-1.9,3.2-3.4-1.45-3.4,1.45ZM9.45,19.95l2.55-1.1,2.6,1.1,1.4-2.4,2.75-.65-.25-2.8,1.85-2.1-1.85-2.15.25-2.8-2.75-.6-1.45-2.4-2.55,1.1-2.6-1.1-1.4,2.4-2.75.6.25,2.8-1.85,2.15,1.85,2.1-.25,2.85,2.75.6,1.45,2.4ZM10.95,15.55l5.65-5.65-1.4-1.45-4.25,4.25-2.15-2.1-1.4,1.4,3.55,3.55Z"/>
        </IconBase>
    )
}

export default VerifiedIcon;